import React from 'react'
import './foot.css'

const footer = () => {
  return (
    <div>
      Made with 🔥 by Yash
    </div>
  )
}

export default footer
